import React, { Component } from "react";

import Interests from "../data/interests";
import styles from "./facts.module.css";

const FactsHeader = props =>
  <header>
    <h2 className={styles.ribbon}>
      {props.title}
    </h2>
  </header>

const Fact = props =>
  <li>
    <h4>{props.title}</h4>
    <span>{props.content}</span>
  </li>

const FactsList = props => {
  return (
    <div className={styles.facts}>
      <ul>
        {Interests.map((interest, index) =>
          <Fact key={index} title={interest.title} content={interest.content} />
        )}
      </ul>
    </div>
  );
}

export default () => (
  <div>
    <FactsHeader title="Bryan's interests" />
    <FactsList />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/facts.js